import { createApp } from 'vue';
import App from './App.vue';
import '@/styles/index.scss';
import '@/styles/font.scss';
import router from './router/index';
// export default (App) => {
// 	const app = createApp(App);
// 	// app.use(router);
// 	app.mount('#app');
// 	app.config.productionTip = false;
// 	app.config.devtools = process.env.NODE_ENV !== 'production';
// };

createApp(App).use(router).mount('#app')